import JSXComponent from "../../../../dist/jsx-render/JSXComponent";
import dom, { Fragment } from "../../../../dist/jsx-render/dom"
import { DynPopup } from "../../../Components/DynPopup";
import { TextComponent } from "../../../Components/TextComponent";
import { WidgetLinks } from "../Widgets/WidgetLinks";
import { LanguageStringComponent } from "../../../Components/LanguageStringComponent";
import { LanguageString } from "../../../Model/LanguageString";
import { ITableColumn } from "../../Table/ITableColumn";
import { TableColumnAlign } from "../../Table/TableColumnAlign";
import { TableColumnTypes } from "../../Table/TableColumnTypes";
import { MsoTable } from "../../Table/MsoTable";
import { EditTypes } from "../../Table/EditTypes";
import { ListItem } from "../../../Model/ListItem";
import { app } from "../../../Frame/App";
import { LinkWidgetModel } from "../Models/LinkWidgetModel";
import { FixedDialog, DialogResult } from "../../FixedDialog";
import { resourceUsage } from "process";

export type PopupLinksComponentProps = {
    widget: WidgetLinks;
}

export class PopupLinksComponent extends JSXComponent {
    props: PopupLinksComponentProps;
    title: LanguageStringComponent;
    data: any[] = [];

    constructor(props: PopupLinksComponentProps) {
        super(props);
    }

    private Columns: ITableColumn[] = [
        { type: TableColumnTypes.Int, dataField: "id", headerCssClass: "d-none", number: 0, cssClass: "d-none" },
        { type: TableColumnTypes.String, dataField: "name", number: 1, width: 220, headerCssClass: "flex-grow-1", headerText: Resources.Common.labelName, align: TableColumnAlign.Left },
        { type: TableColumnTypes.String, dataField: "url", number: 2, width: 220, headerCssClass: "flex-grow-1", headerText: Resources.Common.adresse, align: TableColumnAlign.Left },
        { type: TableColumnTypes.String, dataField: "userName", width: 130, cssClass: "sr-create-user", number: 3, headerText: Resources.Common.user, align: TableColumnAlign.Left },
        { type: TableColumnTypes.Date, dataField: "createDate", width: 110, cssClass: "sr-create-date", number: 4, headerText: Resources.Common.createdOn, align: TableColumnAlign.Left },
        { type: TableColumnTypes.DeleteIcon, dataField: "id", number: 5, width: 40, cssClass:"d-flex justify-content-center" },
    ]

    onSave = (): boolean => {
        // save link data
        this.saveLinkData();

        if (this.title.props.model == null)
            this.title.props.model = new LanguageString();
        this.props.widget.props.title = this.title.props.model;
        this.props.widget.recreate();
        return true;
    }


    element: HTMLElement =
        <DynPopup size="fit" showCancelButton={true} showSaveButton={true} onSave={this.onSave}
            title={Resources['WidgetClient'].widgetLinks} cssClass="popup-link-component">
            {this.renderTitle()}
            {this.renderLinkControl()}

            <div className="mt-4" style={{ height: "10rem" }}>
                <label className="form-label">{Resources['WidgetClient'].allLinks}</label>
                {this.renderTable()}
            </div>
        </DynPopup>

    renderTitle(): HTMLElement {
        this.title = new LanguageStringComponent({
            model: this.props.widget.props.title,
            name: Resources['WidgetClient'].title,
            additionalCssClasses: "name-in-languages",
            maxLength: 250,
            showLabel: true,
            alwaysExpanded: false
        });
        return this.title.render();
    }

    renderLinkControl(): HTMLElement {
        let control: HTMLElement  = 
            <div className="d-flex flex-column mt-3" id="newLinkData">
                <div className="mt-2 d-flex justify-content-between" id="buttonLinkData">
                    <button type="button" class="btn btn-custom" data-toggle="collapse" data-target="#collapseLinkData" role="button" aria-expanded="false" aria-controls="collapseLinkData">
                        <i class="far fa-plus mr-2"></i>{Resources['WidgetClient'].addLink}
                    </button>
                </div>
                <div id="collapseLinkData" className="link-data mt-3 collapse border border-right-0 border-top-0 px-2 py-2" aria-labelledby="buttonLinkData" data-parent="#newLinkData">
                    {this.renderInputControl()}
                    {this.renderCancelButton()}
                </div>
            </div>
        return control;
    }

 
    renderInputControl(): HTMLElement {
        return <Fragment>
                    <label className="form-label">{Resources['WidgetClient'].editLink}</label>
                    <div className="d-flex">
                        <TextComponent
                            model={this.props.widget.widgetModel}
                            field="Name"
                            name={Resources.Common.labelName}
                            showLabel={true}
                            required={false}
                            additionalCssClasses="link-name flex-grow-1" />
                        <TextComponent
                            model={this.props.widget.widgetModel}
                            field="Url"
                            name={Resources.Common.adresse}
                            showLabel={true}
                            required={false}
                            additionalCssClasses="flex-grow-1 ml-1" />
                    </div>
        </Fragment>
    }

    renderCancelButton(): HTMLElement {
        const cancelButtonElement: HTMLElement =
            <div className="d-flex justify-content-end">
                <button type="button" class="btn btn-custom" id="btnCancelLink">{Resources.Common.cancel}</button>
            </div>
        let cancelButton = cancelButtonElement?.firstChild;
        cancelButton?.addEventListener("click", () => {
            this.props.widget.widgetModel = new LinkWidgetModel();
            this.resetLinkControl("hide");
        });

        return cancelButtonElement;
    }

    renderTable(): HTMLElement {
        this.data = this.props.widget.getLinksData();
        let div: HTMLElement = <div className="mso-links-table pb-3 overflow-auto"></div>;
        let table = new MsoTable(div, {
            loadOnCreate: false,
            rowsPerPage: 100,
            fixedLayout: false,
            idField: "id",
            settingsName: "linkList",
            editType: EditTypes.None,
            rowClickCallback: (ev: MouseEvent) => {
                let row = (event.target as HTMLElement).closest(".mt-content-row");
                const id = parseInt((row as HTMLElement).getAttribute("data-id"));
                this.copyToModel(id);
            }, 
        });
        table.props.onDeleteIconClicked = (id: string) => {
            new FixedDialog()
                .showYesNo(Resources['WidgetClient'].deleteLinkMessage)
                .done((res) => {
                    if (res == DialogResult.Yes) {
                        $.ajax({
                            url: app.resolveUrl(`~/api/widget/deleteLinkData/${id}`),
                            type: "POST",
                            success: (result) => {
                                if (result.status ==  1 ) {
                                    table.removeRow(id);
                                } else {
                                    console.log(result.status);
                                }
                            },
                            error: (err) => {
                                console.log(err);
                            }
                        });
                    }
                });
        };
        table.createAll(this.Columns, this.data, null, null);
        return div;
    }

    render(): HTMLElement {
        return this.element;
    }

   
    // copy slected link values to model
    copyToModel = (id: number) => {
        let linkToEdit = this.data.filter(f => f.id == id);
        if (linkToEdit != null && linkToEdit.length > 0) {
            this.props.widget.widgetModel.Id = linkToEdit[0].id;
            this.props.widget.widgetModel.Name = linkToEdit[0].name;
            this.props.widget.widgetModel.Url = linkToEdit[0].url;

            // Edit Model - display inputs
            this.resetLinkControl("show");
        }
    }

    resetLinkControl(mode:string) {
        let control = document.getElementById("collapseLinkData");
        if (control) {
            control.innerHTML = "";
            control.appendChild(this.renderInputControl());
            control.appendChild(this.renderCancelButton());

            if (mode == "show")
                $('.collapse').collapse('show');
            else
                $('.collapse').collapse('hide');
        }
    }

    saveLinkData() {
        if (this.props.widget.widgetModel.Name != "" || this.props.widget.widgetModel.Url != "") {
            $.ajax({
                type: "POST",
                url: app.resolveUrl("~/api/widget/saveLinkData"),
                async: false,
                dataType: 'json',
                contentType: "application/json; charset=utf-8",
                data: JSON.stringify(this.props.widget.widgetModel),
                success: (response) => {
                    this.props.widget.widgetModel = new LinkWidgetModel();
                },
                error: ((response) => {
                    alert(response.statusText + ": " + response.responseText);
                })
            });
        }
    }
}
